<div class="container">
  <div class="head">
    <div mat-dialog-title
         class="head-label">{{ (isEditMode ? 'MENU.SIZES.EDIT_MANUAL_SIZE' : 'MENU.SIZES.CREATE_MANUAL_SIZE') | translate }}</div>
    <mat-icon mat-dialog-close class="head-exit">close</mat-icon>
  </div>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="dish">
      <div class="dish-data">
        <mat-form-field class="dish-name" appearance="fill">
          <mat-label>{{ 'MENU.SIZES.SIZE_NAME' | translate }}</mat-label>
          <input matInput type="text" formControlName="name">
        </mat-form-field>

        <div *ngIf="data.organization.additionalLanguages">
          <mat-form-field class="dish-name" appearance="fill"
                          *ngFor="let lang of data.organization.additionalLanguages">
            <mat-label>{{'MENU.SIZES.SIZE_NAME' | translate}} {{lang}}</mat-label>
            <input matInput formControlName="{{getFormLangName(lang)}}">
          </mat-form-field>
        </div>

        <mat-form-field class="dish-name" appearance="fill">
          <mat-label>{{ 'MENU.DISHES.NEW.PRICE' | translate }}</mat-label>
          <input matInput type="number" min="0" placeholder="00.00" formControlName="price">
        </mat-form-field>

        <mat-form-field class="dish-name" appearance="fill">
          <mat-label>{{ 'MENU.WEIGHT' | translate }}</mat-label>
          <input matInput type="number" min="0" placeholder="00.00" formControlName="weight">
        </mat-form-field>

        <div class="hidden-checkbox">
          <mat-checkbox formControlName="isHidden">
            <label>{{ 'MENU.SIZES.HIDE' | translate }}</label>
          </mat-checkbox>
        </div>

        <mat-form-field class="dish-name" appearance="fill">
          <mat-label>{{ 'MENU.SIZES.LINKED_PRODUCT' | translate }}</mat-label>
          <input matInput type="text" formControlName="linkedProductSearch" [matAutocomplete]="linkedProductAuto">
          <mat-icon *ngIf="form.value['linkedProductSearch']" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearLinkedProduct()">close
          </mat-icon>
          <mat-autocomplete #linkedProductAuto="matAutocomplete">
            <mat-option *ngFor="let product of displayedProducts()" [value]="product.name">
              {{ product.name }}
            </mat-option>
          </mat-autocomplete>
          <mat-hint>{{ 'MENU.SIZES.LINKED_PRODUCT_HINT' | translate }}</mat-hint>
        </mat-form-field>

        <div class="size-image">
          <mat-label>{{ 'MENU.PICTURE' | translate }}</mat-label>
          <app-select-image-field
            [image]="form.value['externalPictureUrl']"
            [overrideUrl]="form.value['externalPictureUrl']"
            [originalUrl]="form.value['externalPictureUrl']"
            [organizationId]="data.organizationId"
            [inputImgDefaultSrc]="'assets/images/dishes/logo-small.png'"
            [allowOverrides]="true"
            (imageChanged)="onPictureChanged($event)"
            style="height: 70px;"
          ></app-select-image-field>
        </div>
      </div>
    </div>
    <div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
    <div class="form-bottom">
      <button
        class="submit"
        mat-button
        [disabled]="form.invalid || isSaving"
      >{{ 'COMMON.SAVE' | translate }}
      </button>
    </div>
  </form>
</div>
